export enum StorageKeys {
  token = 'item_0',
  refreshToken = 'item_1',
  twilioToken = 'item_2',
  userId = 'item_3',
  locale = 'item_4',
  isDoctor = 'item_5',
}
